import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
const getFirstAndLast = dates => {
  if (dates.length === 0) return [undefined, undefined];
  const sorted = [...dates].sort();
  return [sorted[0], sorted[sorted.length - 1]];
};
export const getScheduleTimelineSummary = timeline => {
  var _finalNode$coveredMon, _finalNode$amount;
  const regularNodes = timeline.filter(node => node.kind === 'Regular');
  const finalNode = timeline.find(node => node.kind === 'Final');
  const _getFirstAndLast = getFirstAndLast(regularNodes.map(node => node.date)),
    _getFirstAndLast2 = _slicedToArray(_getFirstAndLast, 2),
    firstDate = _getFirstAndLast2[0],
    lastDate = _getFirstAndLast2[1];
  const regularRun = {
    count: regularNodes.length,
    firstDate,
    lastDate
  };
  if (!finalNode) {
    return {
      regularRun,
      hasCharge: false
    };
  }
  const coveredMonths = (_finalNode$coveredMon = finalNode.coveredMonths) !== null && _finalNode$coveredMon !== void 0 ? _finalNode$coveredMon : [];
  const _getFirstAndLast3 = getFirstAndLast(coveredMonths),
    _getFirstAndLast4 = _slicedToArray(_getFirstAndLast3, 2),
    firstCoveredMonth = _getFirstAndLast4[0],
    lastCoveredMonth = _getFirstAndLast4[1];
  return {
    regularRun,
    finalNode: {
      date: finalNode.date,
      amount: (_finalNode$amount = finalNode.amount) !== null && _finalNode$amount !== void 0 ? _finalNode$amount : undefined,
      coveredMonths: [...coveredMonths].sort(),
      coveredMonthCount: coveredMonths.length,
      firstCoveredMonth,
      lastCoveredMonth
    },
    hasCharge: typeof finalNode.amount === 'number' && finalNode.amount > 0
  };
};